import { IonList } from '@ionic/react';
import styled from 'styled-components';
import { isMobile } from '../../common/utils';
import { AllieListProps } from './List.types';

export const StyledList: any = styled(IonList)`
  width: ${(props: AllieListProps) =>
    props.type === 'full' ? '100%' : 'auto'};
  ${isMobile ? '' : 'padding-left: 10px'};
`;
